import { render, staticRenderFns } from "./DeliverableListCoordinators.vue?vue&type=template&id=1736d5c3&"
import script from "./DeliverableListCoordinators.vue?vue&type=script&lang=js&"
export * from "./DeliverableListCoordinators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1736d5c3')) {
      api.createRecord('1736d5c3', component.options)
    } else {
      api.reload('1736d5c3', component.options)
    }
    module.hot.accept("./DeliverableListCoordinators.vue?vue&type=template&id=1736d5c3&", function () {
      api.rerender('1736d5c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/DeliverableListCoordinators.vue"
export default component.exports